import { EvtHeader } from "components/header";
import { useParams } from "react-router-dom";
import ExtensionForm from "@/modules/work/jobs/extensions/form";

const CreateExtension = () => {
  const { jobId } = useParams();

  return (
    <div className="flex-1">
      <EvtHeader title="Create Extension" />
      <div className="p-6 max-w-md">
        <ExtensionForm jobId={jobId} />
      </div>
    </div>
  );
};

export default CreateExtension;
